import { PdfSectionType } from './PDFRendererTypes';

export const NOTIFY_LOADED_SECTION = 'PDF_RENDERER/NOTIFY_LOADED_SECTION';
export const NOTIFY_LOADED_ADVANCED_REPORT_SECTION =
  'PDF_RENDERER/NOTIFY_LOADED_ADVANCED_REPORT_SECTION';

export const notifyPdfLoadedSection = (section: PdfSectionType) => ({
  type: NOTIFY_LOADED_SECTION,
  payload: section,
});

export const notifyPdfLoadedAdvancedReportSection = (section: string) => ({
  type: NOTIFY_LOADED_ADVANCED_REPORT_SECTION,
  payload: section,
});
